/**
 * Query key factory for booking field queries
 */
export const fieldQueryKeys = {
	service: (id: number) => ['service', id],

	monthAvailability: (
		serviceId: number,
		year: number,
		month: number,
		resources: number[],
		resourceMode: 'any' | 'all',
		excludeBookingId: number
	) => [
		'month-availability',
		serviceId,
		year,
		month,
		resources,
		resourceMode,
		excludeBookingId,
	],

	timeSlots: (
		serviceId: number,
		date: string, // ISO date string for consistency
		resources: number[],
		duration: number,
		slotMode: 'aligned' | 'flexible',
		interval: number,
		resourceMode: 'any' | 'all',
		excludeBookingId: number
	) => [
		'time-slots',
		serviceId,
		date,
		resources,
		duration,
		slotMode,
		interval,
		resourceMode,
		excludeBookingId,
	],

	rangeCapacity: (
		serviceId: number,
		start: string,
		end: string,
		resources: number[],
		resourceMode: 'any' | 'all',
		excludeBookingId: number
	) => [
		'range-capacity',
		serviceId,
		start,
		end,
		resources,
		resourceMode,
		excludeBookingId,
	],

	availableSlots: (
		serviceId: number,
		resources: number[],
		limit: number,
		slotMode: string,
		interval: number,
		duration: number,
		resourceMode: 'any' | 'all',
		excludeBookingId: number
	) => [
		'available-slots',
		serviceId,
		resources,
		limit,
		slotMode,
		interval,
		duration,
		resourceMode,
		excludeBookingId,
	],
};
